module.exports = __webpack_public_path__ + "img/couponicon.e3cc39a2.png";